import { ReactNode, ButtonHTMLAttributes } from 'react'
import clsx from 'clsx'

interface ModalButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    variant?: 'primary' | 'secondary' | 'outline'
    children: ReactNode
    className?: string
    loading?: boolean
}

export default function ModalButton({
    variant = 'secondary',
    children,
    className,
    loading = false,
    disabled,
    ...props
}: ModalButtonProps) {
    return (
        <button
            className={clsx(
                'modal-button',
                {
                    'modal-button-primary': variant === 'primary',
                    'modal-button-secondary': variant === 'secondary',
                    'modal-button-outline': variant === 'outline',
                },
                className
            )}
            disabled={disabled || loading}
            {...props}
        >
            {loading && <span className='modal-button-spinner' />}
            {children}
        </button>
    )
}